<div class='form-group'>
    <input id='OrganizationUnitsTreeFilter' type='text' (input)="filterOrganizationUnits($event)" [(ngModel)]="filter" class='form-control' placeholder='{{"SearchWithThreeDot" | localize}}' >
</div>
<p-tree [value]="treeData"
        selectionMode="checkbox"
        [(selection)]="selectedOus" (onNodeSelect)="nodeSelect($event)" (onNodeUnselect)="onNodeUnselect($event)" [propagateSelectionUp]="false" [propagateSelectionDown]="cascadeSelectEnabled"></p-tree>

<button class="btn btn-primary" (click)="openSelectionModal()">
    <i class="fa fa-plus"></i>
    <span>{{"Add organization unit" | localize}}</span>
</button>
